import { useId, forwardRef, HTMLProps } from "react";
import { cn } from "@/utils/helpers";
import FieldInput from "./components/FieldInput";
import FieldTextarea from "./components/FieldTextarea";
import styles from "./Field.module.css";

export interface FieldProps extends HTMLProps<HTMLInputElement & HTMLTextAreaElement> {
	variant?: "default" | "underlined" | "outlined" | "filled";
	labelText?: string;
	hideLabelText?: boolean;
}

const Field = forwardRef<HTMLInputElement & HTMLTextAreaElement, FieldProps>(({
	type = "text",
	variant = "default",
	labelText,
	hideLabelText = false,
	children,
	className,
	onChange,
    ...props
}, ref) => {
	const id = useId();
	const ariaLabel = labelText && hideLabelText ? labelText : "";
	return (
		<div
			className={cn(styles.Field, styles[`Field_${variant}`], className)}
		>
			{labelText && !hideLabelText ?
				<label
					className={styles.FieldLabel}
					htmlFor={id}>
					{labelText}
					{props.required ?
						<span
							className={styles.FieldRequiredAsterisk}
						>
							*
						</span>
					: ""}
				</label>
			: null}
			<div>
				{type !== "textarea" ?
					<FieldInput
						ref={ref}
						type={type}
						aria-label={ariaLabel}
						onChange={onChange}
						{...props}
					/>
				: null}
				{type === "textarea" ?
					<FieldTextarea
						ref={ref}
						aria-label={ariaLabel}
						onChange={onChange}
						{...props}
					/>
				: null}
				{children}
			</div>
		</div>
	)
})

export default Field